import React, { useState, useRef, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import cohortMeetingWhite from "../../../../../assets/svg/cohortMeeting.svg";
import { getStepperTooltipData } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import { useHistory } from "react-router-dom";
import arrow from "../../../../../assets/images/arrow.png";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import swal from "sweetalert";
import {
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionGiveFeedBack,
  cohortSessionViewFeedBack,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
} from "../dependencies/action";
import SessionsModal from "../../../../common/sessionsModal";
import CohortSummaryModal from "../../../../common/cohortSummaryModal";
import api from "../../../../common/dependencies/utils/Api";
import BasicModal from "../../../../common/summaryMentorModal/Modal";
import "./styles.scss";
import axios from "axios";
import {
  COHORT_NAME_LIST,
  GET_NAMES_DATA,
} from "../../../../common/constants/ApplicationUrl";
import StartupFeedBackModal from "../../../../common/startupFeedBackModal";
import AnimeList from "../../StartupDashboard/ViewAllMentorList/AnimeList";
import makeStyles from "@material-ui/core/styles/makeStyles";
import mentorMiniIcon from "../../../../../assets/svg/mentorsMiniCircle.svg";
import SessionGroupFeedbackModal from "../../../../common/groupSessionNotesModal";
import createCohort from "../../../../../assets/images/Purple button Rectangle.svg";
import iconTooltip from "../../../../../assets/svg/dashboard/iconTooltip.svg";
import LineWithDot from "../../../../../assets/images/Line wit Dot.svg";
import Pagination from "react-js-pagination";
import hashImage from "../../../../../assets/images/hashImage.jpeg";
import { Country, State, City } from "country-state-city";
import ModalVisible from "../CohortGroupSession/Modal/modal";
import { getMentorCohortApplicationList } from "../dependencies/action";

import { getPredefineOptionsList } from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as moment from "moment";
import {
  getNamesList,
  getCohortApplicationCounter,
} from "../../AdminDashboard/AdminMentorAction/dependencies/action";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../../../../common/constants/actionConstants";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "500px",
    paddingTop: "30px",
    paddingBottom: "150px",
    backgroundColor: "#f0f3f5",
    position: "relative",
  },
  headingOne: {
    fontSize: "28px",
    fontWeight: 600,
    fontFamily: "Montserrat",
    color: "#3e4a59",
  },
  headingTwo: {
    color: "rgba(86, 58, 150, 1)",
    fontSize: "40px",
    fontWeight: "600",
    fontFamily: "Montserrat",
  },
  requestsStatusTy: {
    backgroundColor: "#816aaf",
    color: "white",
    fontFamily: "Montserrat",
    padding: "10px 10px",
    borderRadius: "8px",
    fontWeight: 600,
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
  upperDisplay: {
    width: "86%",
    marginTop: "25px",
    padding: "25px 50px",
    background:
      "linear-gradient(90deg, rgba(222, 212, 245,0.8130602582830007) 0%, rgba(247,243,255,1) 100%)",
  },
  messageIconWrapper: {
    height: "100%",
    display: "flex",
    justifyContent: "left",
    alignItems: "center",
    borderRadius: "px",
  },
  lineWithDotContainer: {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lineWithDotUpper: {
    color: "#277acc",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "16px",
  },
  lineWithDot: {
    maxWidth: "none",
    maxHeight: "none",
    width: "150px",
    height: "10px",
    marginLeft: 0,
  },
  lineWithDotLower: {
    color: "#816aaf",
    fontWeight: "bold",
    textAlign: "left",
    fontSize: "14px",
  },
  newMessageButtonWrapper: {
    display: "flex !important",
    justifyContent: "flex-end !important",
  },
  machines: {
    position: "absolute",
    height: "400px",
    bottom: 40,
    right: 20,
  },
  filterContainer2: {
    padding: "10px",
    display: "flex",
  },
  select: {
    fontSize: "16px",
    width: "100%",
    whiteSpace: "nowrap",
    textAlign: "left",
  },
  cursorOnHover: {
    "&:hover": {
      cursor: "pointer",
    },
    [theme.breakpoints.down("md")]: {
      margin: "15px 0",
    },
  },
  lowerButtonsContainer: {
    padding: "0 35%",
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  sendRequestButton: {
    height: "88.0781px !important",
    maxWidth: "none",
  },
  tableContainer: {
    // padding: "10px 10px 20px 10px",
    margin: "0 7% 50px 7%",
  },
  upperDisplayButtonsContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  filterContainer: {
    padding: "40px 7% 0 7%",
    display: "flex",
    alignItems: "center",
  },
  selectContainer: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      marginBottom: "10px",
    },
  },
  rightRotated: { transform: "rotate(-90deg)" },
}));
const CohortCreateSession = (props) => {
  const html = document.getElementsByTagName("html")[0];
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const {
    getNamesList,
    getNamesListData,
    getMentorCohortApplicationList,
    getCohortApplicationCounter,
    getTableCounterData,
    getTableData,
    getStepperTooltipData,
    getStepperData,
    listGroupSession,
    listGroupSessionPaginate,
    listGroupSessionData,
    detailsGroupSession,
    detailsGroupSessionData,
    groupSessionCounter,
    cohortSessionGiveFeedBack,
    cohortSessionViewFeedBack,
    sessionFeedBackData,
    listGroupSessionCounter,
    cohortSessionNotesGiveFeedBack,
    cohortSessionNotesViewFeedBack,
    sessionNotesFeedBackData,
  } = props;
  const [Heading, setHeading] = useState();
  const [InstructionswithRole, setInstructionswithRole] = useState();
  const [SelectPage, setSelectPage] = useState();
  const [activeText, setActiveText] = useState(false);
  const [activeText0, setActiveText0] = useState(false);
  const [activeText2, setActiveText2] = useState(false);
  const [allMentorList, setAllMentorList] = useState();
  const [allStartupList, setAllStartupList] = useState();
  const [activeText3, setActiveText3] = useState(false);
  const [activeText4, setActiveText4] = useState(false);
  const [activeText5, setActiveText5] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [selectedRow, setSelectedRow] = useState("");
  const [modalVisibility, setModalVisibility] = useState(false);
  const [videoUrl, setVideoUrl] = useState();
  const [showVideo, setShowVideo] = useState();
  const [mentorShipReqData, setMentorShipReqData] = useState();
  const [tableList, setTableList] = useState();
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState();
  const history = useHistory();
  const [nameListValue, setNameListValue] = useState([]);

  const [mentorFeedbackModalOpen, setMentorFeedbackModalOpen] = useState(false);
  const [scheduleModalOpen, setScheduleModalOpen] = useState(false);

  const [filterCohortId, setFilterCohortId] = useState("");
  const [cohortnameList, setcohortnameList] = useState([]);
  const [cohortnameId, setcohortnameId] = useState([]);
  const [linkToggleText, setLinkToogleText] = useState(
    "Click to join MAAARG session Link"
  );
  const [feedbackMode, setFeedbackMode] = useState(false);
  const [feedBackReload, setFeedBackReload] = useState(false);
  const loggenInUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const handleLoginClick = () => {
    localStorage.setItem("path", "path");
    history.push({
      pathname: "/cohort-form",
      state: {
        fromPage: "cohort-application",
      },
    });
  };
  const [canDelete,setCanDelete] = useState(false);
  const [fromModule, setFromModule] = useState("");
  const newCountryArray = [];
  const newStateArray = [];
  const [selectedStatus, setSelectedStatus] = useState("");
  const [newCountryOptions, setNewCountryOptions] = useState(newCountryArray);
  const [newStateOptions, setNewStateOptions] = useState(newStateArray);
  const [filterIndustry, setFilterIndustry] = useState("");
  const [filterFunction, setFilterFunction] = useState("");
  const [filterStage, setFilterStage] = useState("");
  const [cohortfilterGo, setcohortfilterGo] = useState(false);
  const [taggingList, setTaggingList] = useState([]);
  const [sessionModalData, setSessionModalData] = useState(null);
  const [sessionModalOpen, setSessionModalOpen] = useState(false);
  const [isShown, setIsShown] = useState(false);
  const [cohortGroupSessionId, setCohortGroupSessionId] = useState("");
  const loggedIn = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [sessionModalChild, setSessionModalChild] = useState(false);
  const [modalFeedbackData, setModalFeedbackData] = useState("");
  const [cohortGroupSessionList, setCohortGroupSessionList] = useState([]);
  const [sessionMomModalOpen, setSessionMomModalOpen] = useState(false);
  const [sessionMomChildData, setSessionMomChildData] = useState("");
  const [videoArr, setVideoArr] = useState([]);

  const setModalIsOpenToTrue = () => {
    setIsShown(!isShown);
  };
  const {
    getStartupApplication,
    startUpApplication,
    startUpApplicationPagineate,
    getCountersStartUpList,
    getCounterStartUp,
    getPredefineOptionsList,
    getPredefineOptions,
    getTableDataPaginate,
  } = props;
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));
  const [linkToggleCopy, setLinkToogleCopy] = useState(false);
  useEffect(() => {
    html.style.overflow = "auto";

    if (linkToggleCopy) {
      setTimeout(() => {
        setLinkToogleCopy(false);
        setLinkToogleText("Click to Copy MAAARG session Link");
      }, 5000);
    }
  }, [linkToggleCopy]);
  useEffect(() => {
    if (feedBackReload) {
      setTimeout(() => {
        let params = {
          userId: loggedIn?.id,
          fromInvitationList: true,
          sessionStatus: selectedStatus,
          pageFilter: {
            pageSize: 10,
            currentPage: 0,
          },
        };
        listGroupSession(params);
        setFeedBackReload(false);
      }, 1500);
    }
  }, [feedBackReload]);

  useEffect(() => {
    let params = {
      userId: loggedIn?.id,
      fromInvitationList: true,
      sessionStatus: selectedStatus,
      pageFilter: {
        pageSize: 10,
        currentPage: 0,
      },
    };
    listGroupSession(params);
  }, []);
  useEffect(() => {
    let params = {
      userId: loggedIn?.id,
      fromInvitationList: true,
    };
    listGroupSessionCounter(params);
  }, []);

  useEffect(() => {
    setSessionModalData(detailsGroupSessionData);
  }, [detailsGroupSessionData]);
  const tableImageData = (key) => {
    return (
      <div
        style={{
          display: "flex",
        }}
        className="borderStartUp9222 forrightalign"
      >
        <div
          className="newuserTooltip decreaseheightformb"
          style={{
            maxWidth: "none",
            objectFit: "contain",
          }}
        >
          <img
            src={key.image !== null && key.image !== "" ? key.image : hashImage}
            onClick={() => ViewProfile(key.username, key.id)}
            className="sidebar-dashboard-icon2 newWidthIconFIx"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              cursor: "pointer",
            }}
          />
          <span
            className="tooltiptext tooltip-bottom "
            style={{
              left: "46px",
              top: "94px",
              width: "150px",
            }}
          >
            View Mentor Profile
          </span>
          <div className="nameandid">{key.applicant_name}</div>
          <p className="nameandid">
            {"M" + key.id.substring(key?.id.length - 6)}
          </p>
        </div>
      </div>
    );
  };
  const tableSpeakerData = (key) => {
    return (
      <>
        <div
          style={{
            display: "flex",
            justifyContent: "",
            // minWidth: "18.9rem",
            // maxWidth: "19rem",
          }}
          className="borderStartUp9222 "
        >
          <div>{key.applicant_name}</div>
          <div>{"M" + key.id.substring(key?.id.length - 6)}</div>
          <div>{key.mentorTopic}</div>
          <div>{key.sessionTime}</div>
          <div>{key.sessionDuration}</div>
          <div
            className="newuserTooltip"
            style={{
              cursor: "pointer",
              position: "absolute",
              padding: "12px",
              right: "0px",
              bottom: "0px",
            }}
          >
            <img
              src={mentorMiniIcon}
              height={40}
              width={40}
              onClick={() => {
                ViewProfile(key.username, key?.id);
              }}
            />
            <span
              className="tooltiptext tooltip-bottom "
              style={{
                left: "46px",
                top: "58px",
                width: "150px",
              }}
            >
              View Mentor Profile
            </span>
          </div>
        </div>
      </>
    );
  };
  const tableSpeakerRow = (item, id) => {
    return (
      <>
        {item !== undefined &&
          item.map(function (key, index) {
            if (
              item.length > 1 &&
              cohortGroupSessionList.find((element) => element === id) !==
                undefined
            )
              return (
                <>
                  {index < 2 ? tableSpeakerData(key) : ""}
                  {index === item.length - 1 ? (
                    <>
                      <td
                        className=""
                        style={{
                          minWidth: "10.4rem",
                        }}
                      ></td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            else
              return (
                <>
                  {tableSpeakerData(key)}
                  {index === item.length - 1 && item.length > 1 ? (
                    <>
                      <td
                        className=""
                        style={{
                          minWidth: "10.4rem",
                        }}
                      ></td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
          })}
      </>
    );
  };

  const tableImageRow = (item, id) => {
    return (
      <>
        {item !== undefined &&
          item.map(function (key, index) {
            if (
              item.length > 1 &&
              cohortGroupSessionList.find((element) => element === id) !==
                undefined
            )
              return (
                <>
                  {index < 2 ? tableImageData(key) : ""}
                  {index === item.length - 1 ? (
                    <>
                      <td className="lastclassviewmore">
                        <div
                          className="d-flex"
                          onClick={() => {
                            setCohortGroupSessionId("");
                            let sample = [];
                            sample = cohortGroupSessionList;
                            sample = sample.filter(function (item) {
                              return item !== id;
                            });
                            setCohortGroupSessionList(sample);
                          }}
                        >
                          <div
                            className="color-green21 "
                            style={{
                              position: "relative",
                              left: "-0.35rem",
                              top: "-0.1rem",
                              whiteSpace: "nowrap",
                              margin: "0.75rem",
                            }}
                          >
                            View More
                          </div>
                          <div
                            style={{
                              cursor: "pointer",
                              bottom: "0.5rem",
                              right: "1.25rem",
                              marginLeft: "0.5rem",
                            }}
                            className="arrowCollapse"
                          >
                            <img
                              style={{
                                width: "37%",
                                marginRight: "1.5rem",
                                marginLeft: "1rem",
                              }}
                              src={arrow}
                            />
                          </div>
                        </div>
                      </td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
            else
              return (
                <>
                  {tableImageData(key)}
                  {index === item.length - 1 && item.length > 2 ? (
                    <>
                      <td className="lastclassviewmore">
                        <div
                          className="d-flex"
                          onClick={() => {
                            setCohortGroupSessionId(id);
                            if (
                              cohortGroupSessionList.find(
                                (element) => element === id
                              ) === undefined
                            )
                              setCohortGroupSessionList((listData) => [
                                ...listData,
                                id,
                              ]);
                            else {
                              let sample = [];
                              sample = cohortGroupSessionId;
                              sample = sample.filter(function (item) {
                                return item !== id;
                              });
                              setCohortGroupSessionList(sample);
                            }
                          }}
                        >
                          <div
                            className="color-green21 newone"
                            style={{
                              position: "relative",
                              left: "-0.35rem",
                              top: "-0.1rem",
                              whiteSpace: "nowrap",
                              margin: "0.75rem",
                            }}
                          >
                            View Less
                          </div>
                          <div
                            style={{
                              cursor: "pointer",
                              bottom: "0.5rem",
                              right: "1.25rem",
                              marginLeft: "0.95rem",
                            }}
                            className="arrowCollapse"
                          >
                            <img
                              style={{
                                width: "39%",
                                marginRight: "1.5rem",
                                transform: "rotate(270deg)",
                                marginLeft: "1rem",
                              }}
                              src={arrow}
                            />
                          </div>
                        </div>
                      </td>
                    </>
                  ) : (
                    ""
                  )}
                </>
              );
          })}
      </>
    );
  };
  const getSessionDetails = (id) => {
    let params = {
      cohortGroupSessionId: id,
      userId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    detailsGroupSession(params);
  };
  useEffect(() => {
    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "POST",
    //   data: {
    //     listKey: "Mentor",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        listKey: "Mentor",
      })
      .then((res) => {
        setAllMentorList(res.data?.data);
      })
      .catch((err) => {});

    // axios({
    //   url: GET_NAMES_DATA,
    //   method: "POST",
    //   data: {
    //     listKey: "Startup",
    //   },
    // })
    api
      .POST(GET_NAMES_DATA, {
        listKey: "Startup",
      })
      .then((res) => {
        setAllStartupList(res.data?.data);
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
    getStepperTooltipData();
  }, []);
  useEffect(() => {
    setHeading(getStepperData?.Guidedinstructions[0].Heading);
    setInstructionswithRole(
      getStepperData?.Guidedinstructions[0].InstructionswithRole
    );
    setSelectPage(getStepperData?.Guidedinstructions[0].SelectPage);
  }, [getStepperData]);

  const loginrole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  if (
    (loginrole === "Mentor" || loginrole === "Startup") &&
    !localStorage.getItem("setloggedin")
  ) {
    localStorage.setItem("cohortInvitation", "cohortInvitation");
  } else if (
    (loginrole === "Mentor" || loginrole === "Startup") &&
    localStorage.getItem("setloggedin")
  ) {
    localStorage.removeItem("cohortInvitation");
  } else {
    localStorage.removeItem("cohortInvitation");
    history.push(loginrole != "Mentor" ? "/startup-dashboard" : "/dashboard");
  }
  useEffect(() => {
    // localStorage.setItem("cohortInvitation", "cohortInvitation");
    setTimeout(() => {
      localStorage.removeItem("mentorMentorships");
      localStorage.removeItem("cohortMentors");
      localStorage.removeItem("cohortStartup");
      localStorage.removeItem("myrequestMenu");
      localStorage.removeItem("startupListMentor");
      localStorage.removeItem("cohortAdminMentorships");
      localStorage.removeItem("CohortMentorRequest");
      localStorage.removeItem("cohortProgram");
      localStorage.removeItem("cohortMatchTable");
      localStorage.removeItem("CohortGroupSession");
      localStorage.removeItem("myRequests");
      localStorage.removeItem("cohortMentorshipsStartup");
    }, 1000);
    localStorage.removeItem("path");
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Name",
                value: "select",
              };
              setcohortnameList((oldArray) => [...oldArray, arr2]);
            }
            if (item.name !== "" && item.name !== null) {
              let arr = {
                label: item.name,
                value: item.id,
              };
              if (res.data.data.length >= cohortnameList.length)
                setcohortnameList((oldArray) => [...oldArray, arr]);
            }
          });
      })
      .catch((err) => {});
    // axios({
    //   url: COHORT_NAME_LIST,
    //   method: "post",
    //   data: {
    //     status: "VERIFIED",
    //     mentorId:
    //       localStorage.getItem("SavedLoggedInData") &&
    //       JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    //   },
    // })
    api
      .POST(COHORT_NAME_LIST, {
        status: "VERIFIED",
        mentorId:
          localStorage.getItem("SavedLoggedInData") &&
          JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      })
      .then((res) => {
        res.data.data &&
          res.data.data.map((item, index) => {
            if (index === 0) {
              let arr2 = {
                label: "Select Cohort Id",
                value: "select",
              };
              setcohortnameId((oldArray) => [...oldArray, arr2]);
            }
            let arr = {
              label: `C${item.id.slice(-6)}`,
              value: item.id,
            };
            if (res.data.data.length >= cohortnameId.length)
              setcohortnameId((oldArray) => [...oldArray, arr]);
          });
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    let params = {
      listKey: "Startup",
    };
    getNamesList(params);
  }, []);
  useEffect(() => {
    let params = {
      cohortId: filterCohortId,
      sortKey: "name",
      sortOrder: "ASC",
      country: null,
      industry:
        filterIndustry && filterIndustry == "select" ? "" : filterIndustry,
      function:
        filterFunction && filterFunction == "select" ? "" : filterFunction,
      stage: filterStage && filterStage == "select" ? "" : filterStage,
      searchField: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
      searchKey: null,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 10,
        sortField: "date_applied",
        sortOrder: "DESC",
      },
    };
    getMentorCohortApplicationList(params);
  }, [cohortfilterGo]);
  useEffect(() => {
    getNamesListData?.forEach((element, index) => {
      if (index === 0) {
        let arr2 = {
          value: "Select",
          label: "Select Startup",
        };
        setNameListValue((oldArray) => [...oldArray, arr2]);
      }
      let arr = {
        value: element.id,
        label: element.name,
      };
      if (getNamesListData.length >= nameListValue.length)
        setNameListValue((oldArray) => [...oldArray, arr]);
    });
  }, [getNamesListData]);
  useEffect(() => {
    let params = {
      mentorId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
    };
    getCohortApplicationCounter(params);
  }, []);
  useEffect(() => {
    getPredefineOptionsList();
    Country.getAllCountries().map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newCountryArray.push(newObject);
      setNewCountryOptions(newCountryArray);
    });
    State.getStatesOfCountry("IN").map((item) => {
      const newObject = {
        value: item.isoCode,
        label: item.name,
      };

      newStateArray.push(newObject);
      setNewStateOptions(newStateArray);
    });
  }, []);

  useEffect(() => {
    getPredefineOptionsList();
  }, []);
  useEffect(() => {
    setActiveText0(true);
    getTableDataStatus("");
    setSelectedStatus("");
  }, []);
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      userId: loggedIn?.id,
      fromInvitationList: true,
      sessionStatus: selectedStatus,
      pageFilter: {
        pageSize: 10,
        currentPage: pageNumber - 1,
      },
    };
    listGroupSession(params);
  };

  useEffect(() => {
    setTableList(startUpApplication);
    let data = startUpApplication?.requestJson;
    setMentorShipReqData(data);
  }, [startUpApplication]);

  const getTableDataStatus = (status) => {
    let params = {
      userId: loggedIn?.id,
      fromInvitationList: true,
      sessionStatus: status === undefined ? selectedStatus : status,
      pageFilter: {
        pageSize: 10,
        currentPage: 0,
      },
    };
    listGroupSession(params);
  };
  const ViewProfile = (item, id) => {
    setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };

  const onBroadcastSelectionChange = (item, checked) => {
    const isThere = taggingList.find((ele) => {
      if (ele == item.id) return true;
    });
    if (checked) {
      if (!isThere) {
        setTaggingList([...taggingList, item.id]);
      }
    } else {
      if (isThere) {
        let newArray = taggingList.filter((ele) => ele != item.id);
        setTaggingList(newArray);
      }
    }
  };
  useEffect(() => {
    if (sessionFeedBackData !== undefined)
      setModalFeedbackData(sessionFeedBackData);
  }, [sessionFeedBackData]);
  useEffect(() => {
    if (sessionNotesFeedBackData !== undefined)
      setSessionMomChildData(sessionNotesFeedBackData);
  }, [sessionNotesFeedBackData]);

  const getFeedBackData = (id) => {
    let params = {
      cohortGroupSessionId: id,
      userId: loggedIn?.id,
    };
    cohortSessionViewFeedBack(params);
  };
  const newfunctionTime = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1).subtract(60, "minutes").format("DD-MM-YYYY HH:mm A");
    // let beforetime1 = moment(sessionStartTime, "DD-MM-YYYY HH:mm A")
    //   .subtract(60, "minutes")
    //   .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      swal({
        title: "Meeting Not Started",
        text: `Cannot join meeting before scheduled time.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        swal({
          title: "Meeting Completed",
          text: `Cannot join a completed meeting.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          window.open(item?.vcUrl, "_blank");
        } else if (presentTime < beforetime1) {
          swal({
            title: "Meeting Not Started",
            text: `Cannot join meeting before scheduled time.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        } else {
          swal({
            title: "Scheduled Time Over",
            text: `You cannot join meeting.`,
            icon: "error",
            // timer: 1500,
            // buttons: false,
          });
        }
      } else {
        swal({
          title: "Meeting Not Started",
          text: `Cannot join meeting before scheduled time.`,
          icon: "error",
          // timer: 1500,
          // buttons: false,
        });
      }
    } else if (sessionYear < currentYear) {
      swal({
        title: "Scheduled Time Over",
        text: `You cannot join meeting.`,
        icon: "error",
        // timer: 1500,
        // buttons: false,
      });
    }
  };
  const newfunctionFeedBackBoolean = (item) => {
    let currentYear = moment().format("YYYY");
    let currentMonth = moment().format("MM");
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A");
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionStartTime1 = moment(sessionTime);
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");
    let beforetime1 = moment(sessionStartTime1, "DD-MM-YYYY HH:mm A")
      .subtract(60, "minutes")
      .format("DD-MM-YYYY HH:mm A");
    let endTime = moment(sessionTime)
      .add(sessionDuration + 1, "hours")
      .format("DD-MM-YYYY HH:mm A");

    if (
      sessionYear > currentYear ||
      (sessionYear == currentYear && sessionMonth > currentMonth)
    ) {
      return false
    } else if (currentMonth == sessionMonth) {
      if (presentDate > sessionDate) {
        return true
      } else if (sessionDate === presentDate) {
        if (presentTime >= beforetime1 && endTime >= presentTime) {
          return false
        } else if (presentTime < beforetime1) {
          return false
        } else {
          return true
        }
      } else {
       return false
      }
    } else if (sessionYear < currentYear) {
      return true
    }
  };
  const testSessionTextVisibility=(item)=>{
    let currentYear=  moment().format("YYYY") 
    let currentMonth=  moment().format("MM") 
    let presentTime = moment(new Date()).format("DD-MM-YYYY HH:mm A")
    let sessionYear = moment(item?.sessionStartDate).format("YYYY");
    let sessionMonth = moment(item?.sessionStartDate).format("MM");
    let sessionTime = moment(item?.sessionStartDate);
    let sessionDuration = item?.sessionDuration;
    let sessionStartTime = moment(sessionTime).format("DD-MM-YYYY HH:mm A");
    let sessionDate = moment(item?.sessionStartDate).format("DD-MM-YYYY");
    let presentDate = moment().format("DD-MM-YYYY");

    let endTime = moment(sessionTime).add(sessionDuration + 1,'hours').format("DD-MM-YYYY HH:mm A");
      if(sessionYear >currentYear || sessionYear == currentYear && sessionMonth>currentMonth){
        return true
      }
      else if(currentMonth == sessionMonth ){
       if(presentDate > sessionDate){
        return false
       }
       else   if(sessionDate === presentDate )
       {
        if(presentTime  >= sessionStartTime && endTime >= presentTime)
        { 
          return true
        }
        else if(presentTime < sessionStartTime)
        {
          return true
        }
        else {
       return false
        }
       }
       else if(presentDate < sessionDate) {
        return true

       }
      }
      else if(sessionYear == currentYear && sessionMonth < currentMonth){
        return false
      }
  }
  const roundUP= (num, decimalPlaces = 0)=> {
    var p = Math.pow(10, decimalPlaces);
    var n = (num * p) * (1 + Number.EPSILON);
    return Math.round(n) / p;
}
const handleView = (videourl,videoArray,cohortAdminId) => {
  setVideoUrl(videourl);
  setShowVideo(true);
  if(videoArray !== undefined && videoArray!== null && videoArray !== "" &&  videoArray?.length > 0)
  setVideoArr(videoArray);
  if(cohortAdminId == loggedIn?.id || loggedIn?.role == "Admin")
  {
    setCanDelete(true)
  }
  else{
    setCanDelete(false)
  }
};
  return (
    <>
      <div className="cohortsessiondatadiv">
        <div
          className="dashboard-main2 cohortinvitediv"
          style={{ background: "none" }}
        >
          <div
            className="MentorDashboard-CreateCohort"
            style={{ display: "none" }}
          >
            <div
              className="dashboard-bottom-btn4 topbackbtnmentorlist"
              style={{ background: "transparent", border: "none" }}
            >
                 <BasicModal
                videoUrl={videoUrl}
                open={showVideo}
                setOpen={setShowVideo}
                videoList={videoArr}
              />
              <SessionsModal
                modalVisibility={sessionModalOpen}
                setModalVisibility={setSessionModalOpen}
                modalData={sessionModalData}
                setModalOpen={setModalOpen}
                openEditModal={setEditModalVisibility}
                parentData={setSessionModalChild}
                fromModule="groupSessions"
                fromPage="invitationPage"
                allMentorList={allMentorList}
                allStartupList={allStartupList}
                onBroadcastSelectionChange={onBroadcastSelectionChange}
                setTaggingList={setTaggingList}
                taggingList={taggingList}
              />
              {mentorFeedbackModalOpen && mentorFeedbackModalOpen === true && (
                <StartupFeedBackModal
                  modalVisibility={mentorFeedbackModalOpen}
                  setModalVisibility={setMentorFeedbackModalOpen}
                  cohortSession={true}
                  postFeedBack={cohortSessionGiveFeedBack}
                  viewMode={feedbackMode} //true if view feedback, false if post feedback
                  feedBackData={feedbackMode ? modalFeedbackData : ""} // if viewMode is true, show the rating
                  parentData={setFeedBackReload}
                  cohortGroupId={cohortGroupSessionId}
                />
              )}
              {sessionMomModalOpen && sessionMomModalOpen === true && (
                <SessionGroupFeedbackModal
                  modalVisibility={sessionMomModalOpen}
                  setModalVisibility={setSessionMomModalOpen}
                  postFeedBack={cohortSessionNotesGiveFeedBack}
                  viewMode={feedbackMode} //true if view feedback, false if post feedback
                  modalData={sessionMomChildData}
                  parentData={setFeedBackReload}
                  fromPage={"invitationPage"}
                  cohortGroupId={cohortGroupSessionId}
                />
              )}
              {modalOpen && (
                <CohortSummaryModal
                  setModalVisibility={setModalOpen}
                  fromModule={fromModule}
                  modalVisibility={modalOpen}
                  cohortId={modalData}
                  fromPage={"cohortSessions"}
                />
              )}
              <ModalVisible
                modalOpen={scheduleModalOpen}
                allMentorList={allMentorList}
                allStartupList={allStartupList}
                setModalOpen={setScheduleModalOpen}
                onBroadcastSelectionChange={onBroadcastSelectionChange}
                setTaggingList={setTaggingList}
                taggingList={taggingList}
              />
            </div>

            <div className="cohort-Application top-btn mainfirstcohortbtndiv newuserTooltip mt-4 mr-2">
              <img
                onClick={() => {
                  handleLoginClick();
                }}
                height="auto"
                className=""
                style={{ visibility: "hidden" }}
                src={createCohort}
                alt="Slide 1 Mockup 6"
              />
              <div
                className="centred mainfirstcohortbtn"
                style={{ left: "48%" }}
              >
                Create
                <br /> A Cohort
              </div>
              <span
                className="tooltiptext  tooltip-bottom"
                style={{
                  left: "76px",
                  top: "95px",
                  width: "auto",
                  padding: "3px 12px",
                }}
              >
                Click to Create A Cohort
              </span>
            </div>
          </div>
          <div className="iconWith-heading cohortappiconwith">
            <div style={{ width: "100%" }}>
              <h3
                className="sub-heading fadeInDown wow"
                style={{ color: "#262838", fontWeight: 600, fontSize: "28px" }}
              >
                MAARG Portal by Startup India
              </h3>
              <h3 className="dashboard-sub-heading fadeInDown wow">
                COHORT SESSION INVITATIONS RECEIVED
              </h3>
            </div>
            <div
              className="tooltipshow eyeIcon"
              // onClick={() => {
              //   // html.style.overflow = "hidden";

              //   if (html.style.overflow == "auto") {
              //     html.style.overflow = "hidden";
              //   } else {
              //     html.style.overflow = "auto";
              //   }
              // }}
            >
              <div className="newuserTooltip">
                <img
                  className="iconbtn top-btn"
                  src={iconTooltip}
                  onClick={() => {
                    setModalIsOpenToTrue();
                    if (html.style.overflow == "auto") {
                      html.style.overflow = "hidden";
                    } else {
                      html.style.overflow = "auto";
                    }
                  }}
                  width={60}
                />{" "}
                <span
                  className="tooltiptext tooltip-bottom "
                  style={{ width: "130px", top: "50px", left: "20px" }}
                >
                  View Instructions
                </span>
              </div>
            </div>
            {isShown && (
              <div>
                <AnimeList
                  setModalIsOpenToTrue={setModalIsOpenToTrue}
                  Heading={Heading}
                  InstructionswithRole={InstructionswithRole}
                  SelectPage={SelectPage}
                />
              </div>
            )}
          </div>
          {/* <div
            className="dashboard-bottom-btn top-btn dashboardbelowBtn newuserTooltip createcohortsessionbtn"
            onClick={() => {
              localStorage.removeItem("CohortGroupSession");
              localStorage.setItem(
                "sessionRecording",
                "sessionRecording"
              );
              window.location.reload();  
            }}
            style={{position:"relative",left:"4.15rem",fontSize:"16px"}}
          >
            <p
              style={{ cursor: "pointer",fontSize:"16px" }}
              className="text-white3 createcohortsessionbtnpara"
            >
              SESSION RECORDINGS
            </p>
            <span
              className="tooltiptext tooltip-bottom"
              style={{ left: "230px", top: "60px", width: "220px" }}
            >
              Click to view Session Recordings
            </span>
          </div> */}
        </div>

        <div className="col-md-11 display-center mobileviewcohortappli">
          <div className="admin-bottom-cardNew row mobileviewmentorbelow">
            <div className="row">
              <div
                className="col-md-2 col-sm-12 chrtsssninvrecicon"
                style={{
                  position: "relative",
                  // left: "2rem"
                }}
              >
                <img src={cohortMeetingWhite} style={{ width: "39%" }} />
              </div>
              <div
                className="col-md-2 col-sm-12 createsessionbtn"
                style={{
                  position: "relative",
                  top: "0.5rem",
                  // right: "2rem"
                }}
              >
                <div className="dashboard-bottom-btn2 gropu-btns">
                  <p className="text-white2">GROUP SESSIONS</p>
                </div>
              </div>
              <div
                className="col-8 d-flex justify-content-between align-items-center sessioninviteheaderdesktop"
                style={{ position: "relative", left: "-2rem" }}
              >
                <div
                  className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip"
                  style={{ position: "relative", left: "2rem" }}
                >
                  <p
                    onClick={() => {
                      setActiveText0(true);
                      setActiveText(false);
                      setActiveText2(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      getTableDataStatus("");
                      setSelectedStatus("");
                    }}
                    style={{
                      color: activeText0 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className="admindasheaderoptions00 applicationHeading600001"
                  >
                    TOTAL SESSIONS :{" "}
                    {groupSessionCounter !== undefined
                      ? groupSessionCounter.totalCount
                      : 0}
                  </p>
                  <span className="tooltiptext   tooltip-bottom group-01">
                    Click to View Total Sessions
                  </span>
                  {activeText0 ? (
                    <img
                      className="requestStatusBar statusBarLine00"
                      src={LineWithDot}
                      style={{
                        width: "12.8vw",
                        left: "-0.9rem",
                        position: "relative",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div
                  className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip"
                  style={{ position: "relative", left: "2rem" }}
                >
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText(true);
                      setActiveText2(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      getTableDataStatus("SCHEDULED");
                      setSelectedStatus("SCHEDULED");
                    }}
                    style={{
                      color: activeText ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className="admindasheaderoptions00 applicationHeading600001"
                  >
                    SCHEDULED :{" "}
                    {groupSessionCounter !== undefined
                      ? groupSessionCounter.scheduledCount
                      : 0}
                  </p>
                  <span className="tooltiptext   tooltip-bottom group-02">
                    Click to View Scheduled Sessions
                  </span>
                  {activeText ? (
                    <img
                      className="requestStatusBar statusBarLine00"
                      src={LineWithDot}
                      style={{
                        width: "10.4vw",
                        left: "-0.9rem",
                        position: "relative",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip"
                  style={{ position: "relative", left: "0.75rem" }}
                >
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText2(true);
                      setActiveText(false);
                      setActiveText3(false);
                      setActiveText4(false);
                      setActiveText5(false);
                      setSelectedStatus("COMPLETED");
                      getTableDataStatus("COMPLETED");
                    }}
                    style={{
                      color: activeText2 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className="admindasheaderoptions00 applicationHeading600001"
                  >
                    COMPLETED :{" "}
                    {groupSessionCounter !== undefined
                      ? groupSessionCounter.completedCount
                      : 0}
                  </p>
                  <span className="tooltiptext   tooltip-bottom group-03">
                    Click to View Completed Sessions
                  </span>
                  {activeText2 ? (
                    <img
                      className="requestStatusBar positionBar000"
                      src={LineWithDot}
                      style={{
                        width: "10.2vw",
                        left: "-0.9rem",
                        position: "relative",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div
                  className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip"
                  style={{ position: "relative", right: "1rem" }}
                >
                  <p
                    onClick={() => {
                      setActiveText0(false);
                      setActiveText2(false);
                      setActiveText(false);
                      setActiveText3(true);
                      setActiveText4(false);
                      setActiveText5(false);
                      setSelectedStatus("CANCELLED");
                      getTableDataStatus("CANCELLED");
                    }}
                    style={{
                      color: activeText3 ? "#277acc" : "#838186",
                      fontSize: "18px",
                    }}
                    className="admindasheaderoptions00 applicationHeading600001"
                  >
                    CANCELLED :{" "}
                    {groupSessionCounter !== undefined
                      ? groupSessionCounter.cancelledCount
                      : 0}
                  </p>
                  <span className="tooltiptext   tooltip-bottom group-04">
                    Click to View Canceled Sessions
                  </span>
                  {activeText3 ? (
                    <img
                      className="requestStatusBar positionBar000"
                      src={LineWithDot}
                      style={{
                        width: "9.8vw",
                        left: "-0.9rem",
                        position: "relative",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
            <div className="sessioninviteheadermobile">
              <div
                className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip createsessionmobile1"
                style={{
                  position: "relative",
                }}
              >
                <p
                  onClick={() => {
                    setActiveText0(true);
                    setActiveText(false);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("");
                    setSelectedStatus("");
                  }}
                  style={{
                    color: activeText0 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className="admindasheaderoptions00 applicationHeading600001"
                >
                  TOTAL SESSIONS :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.totalCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-01">
                  Click to View Total Sessions
                </span>
                {activeText0 ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "12.8vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>

              <div
                className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip createsessionmobile2"
                style={{
                  position: "relative",
                }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText(true);
                    setActiveText2(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    getTableDataStatus("SCHEDULED");
                    setSelectedStatus("SCHEDULED");
                  }}
                  style={{
                    color: activeText ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className="admindasheaderoptions00 applicationHeading600001"
                >
                  SCHEDULED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.scheduledCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-02">
                  Click to View Scheduled Sessions
                </span>
                {activeText ? (
                  <img
                    className="requestStatusBar statusBarLine00"
                    src={LineWithDot}
                    style={{
                      width: "10.4vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip createsessionmobile3"
                style={{
                  position: "relative",
                  // left: "0.75rem"
                }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(true);
                    setActiveText(false);
                    setActiveText3(false);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("COMPLETED");
                    getTableDataStatus("COMPLETED");
                  }}
                  style={{
                    color: activeText2 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className="admindasheaderoptions00 applicationHeading600001"
                >
                  COMPLETED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.completedCount
                    : 0}
                </p>
                <span className="tooltiptext   tooltip-bottom group-03">
                  Click to View Completed Sessions
                </span>
                {activeText2 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "10.2vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div
                className="col-xs-6 col-sm-6 col-md-1 col-lg- newuserTooltip createsessionmobile4"
                style={{
                  position: "relative",
                }}
              >
                <p
                  onClick={() => {
                    setActiveText0(false);
                    setActiveText2(false);
                    setActiveText(false);
                    setActiveText3(true);
                    setActiveText4(false);
                    setActiveText5(false);
                    setSelectedStatus("CANCELLED");
                    getTableDataStatus("CANCELLED");
                  }}
                  style={{
                    color: activeText3 ? "#277acc" : "#838186",
                    fontSize: "18px",
                  }}
                  className="admindasheaderoptions00 applicationHeading600001"
                >
                  CANCELLED :{" "}
                  {groupSessionCounter !== undefined
                    ? groupSessionCounter.cancelledCount
                    : 0}
                </p>
                <span className="tooltiptext tooltip-bottom group-04">
                  Click to View Canceled Sessions
                </span>
                {activeText3 ? (
                  <img
                    className="requestStatusBar positionBar000"
                    src={LineWithDot}
                    style={{
                      width: "9.8vw",
                      left: "-0.9rem",
                      position: "relative",
                    }}
                  />
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="totalTableCount">
            Total Cohort Applications :{" "}
            {listGroupSessionPaginate?.totalElements} &lt;{" "}
            {listGroupSessionPaginate?.currentPage} of{" "}
            {listGroupSessionPaginate?.numPages} &gt;{" "}
          </div>
          {listGroupSessionData && listGroupSessionData?.length > 0 ? (
            <div>
              <div className="table-container mt-2">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th
                        style={{ verticalAlign: "middle" }}
                        className="fixColumbnWidth4"
                      >
                        {" "}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          NO.
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth sessiondetail-01"
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          SESSION DETAILS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth4"
                        colspan="2"
                        style={{
                          whitespace: "nowrap",
                          verticalAlign: "middle",
                          fontSize: "15.3px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                          }}
                        >
                          SPEAKERS
                        </div>
                      </th>
                      <th
                        className="fixColumbnWidth7"
                        style={{
                          verticalAlign: "middle",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "center",
                            verticalAlign: "middle",
                            minWidth: "8rem",
                          }}
                        >
                          STATUS
                        </div>
                      </th>
                      {loggenInUser?.role !== "Admin" ? (
                        <th style={{ width: "3%" }}>FEEDBACK</th>
                      ) : (
                        ""
                      )}
                    </tr>
                  </thead>
                  {listGroupSessionData &&
                    listGroupSessionData.map((item, index) => {
                      const sessionTime = item.sessionTime.split(":");

                      var date1 = new Date(
                        null,
                        null,
                        null,
                        sessionTime[0],
                        sessionTime[1]
                      );
                      return (
                        <>
                          <tbody>
                            <tr>
                              <td style={{ verticalAlign: "top" }}>
                                <div>
                                  {index +
                                    1 +
                                    10 *
                                      (listGroupSessionPaginate.currentPage -
                                        1)}
                                </div>
                              </td>
                              <td className="tiltletopic">
                                <div>
                                  Title/Topic : {item?.sessionTitle}
                                  <br />
                                  Date :{" "}
                                  {moment(item?.sessionDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                  <br />
                                  Time :{" "}
                                  {/* {moment(item.startTime).format("hh:mm A")} */}
                                  {moment(date1).format("hh:mm A")}
                                  {/* {item.sessionTime} */}
                                  <br />
                                  Duration : {roundUP(item?.sessionDuration,2)} hrs
                                  <br />
                                  <div>
                                    {item.sessionFormat === "ONLINE"
                                      ? "On MAARG Platform"
                                      : item.sessionFormat}
                                  </div>
                                  {item.sessionFormat === "ONLINE" &&
                                  item.sessionStatus === "SCHEDULED" && testSessionTextVisibility(item) &&  loggedIn?.role !== "Admin" &&
                                  item.sessionStatus !== "CANCELLED" &&
                                  item.sessionStatus !== "COMPLETED"  ? (
                                    <div
                                      className="d-flex"
                                      style={{
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div
                                        className="d-flex justify-content-end newuserTooltip"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <a
                                          id="myLink"
                                          // href={item.vcUrl}
                                          href={"Javascript:void(0)"}
                                          // target="_blank"
                                          className="color-green"
                                          onClick={() => {
                                            newfunctionTime(item);
                                          }}
                                        >
                                          Click to join the session
                                        </a>
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={{
                                            left: "15px",
                                            top: "30px",
                                            width: "305px",
                                            height: "45px",
                                          }}
                                        >
                                          All Chats and Video Discussions may be
                                          recorded for quality purposes
                                        </span>
                                      </div>
                                      <div
                                        className="d-flex justify-content-end newuserTooltip"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => {
                                          navigator.clipboard.writeText(
                                            `You are Invited to a scheduled MAARG meeting:\n\nTopic : MAARG Meeting \nTime : ${moment(
                                              item?.sessionStartDate
                                            ).format("MMM. D, YYYY")} ${moment(
                                              item?.sessionStartDate
                                            ).format("hh:mm a")} (${
                                              moment
                                                .tz(
                                                  item?.sessionStartDate,
                                                  Intl.DateTimeFormat().resolvedOptions()
                                                    .timeZone
                                                )
                                                .format("z")
                                                .includes("-")
                                                ? "GMT" +
                                                  moment
                                                    .tz(
                                                      item?.sessionStartDate,
                                                      Intl.DateTimeFormat().resolvedOptions()
                                                        .timeZone
                                                    )
                                                    .format("z")
                                                : moment
                                                    .tz(
                                                      item?.sessionStartDate,
                                                      Intl.DateTimeFormat().resolvedOptions()
                                                        .timeZone
                                                    )
                                                    .format("z")
                                            })
                                                  \nDuration (Hours): ${
                                                    item?.sessionDuration
                                                  }\n\nJoin MAARG Meeting:\n${
                                              item.vcUrl
                                            }`
                                          );
                                          // navigator.clipboard.writeText(
                                          //   `Meeting at : ${moment(
                                          //     item.sessionDate
                                          //   ).format(
                                          //     "DD-MM-YYYY"
                                          //   )} ${item?.sessionTime}\nDuration (Hours): ${
                                          //     item?.sessionDuration
                                          //   }\nJoin MAARG Meeting:\n${item?.vcUrl}`
                                          // )
                                          // navigator.clipboard.writeText(
                                          //   item.vcUrl
                                          // );
                                          setLinkToogleCopy(true);
                                          setLinkToogleText(
                                            "Your MAARG Session Link is copied"
                                          );
                                        }}
                                      >
                                        <span
                                          className="tooltiptext tooltip-bottom"
                                          style={
                                            linkToggleCopy
                                              ? {
                                                  left: "-35px",
                                                  top: "30px",
                                                  width: "240px",
                                                  backgroundColor:
                                                    "rgb(184,153,207)",
                                                }
                                              : {
                                                  left: "-35px",
                                                  top: "30px",
                                                  width: "240px",
                                                  backgroundColor: "#816ab0",
                                                }
                                          }
                                        >
                                          {linkToggleText}
                                        </span>
                                        <ContentCopyIcon />
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </div>
                                <div></div>
                                <div
                                  className="d-flex justify-content-end newuserTooltip"
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    width: "40px",
                                    display: "flex",
                                    float: "right",
                                    marginTop: "1rem",
                                  }}
                                  onClick={() => {
                                    setSessionModalOpen(true);
                                    getSessionDetails(
                                      item?.cohortGroupSessionId
                                    );
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg>
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "24px",
                                      top: "24px",
                                      width: "150px",
                                    }}
                                  >
                                    View Session Details
                                  </span>
                                </div>
                              </td>
                              <td className="mobilehiddendiv">
                                <div>
                                  {item?.cohortApplication?.program_name}
                                </div>
                                <div>Title/Topic : {item?.sessionTitle}</div>

                                <div>
                                  Date :{" "}
                                  {moment(item?.sessionDate).format(
                                    "DD/MM/YYYY"
                                  )}
                                </div>
                                <div>
                                  Time :{" "}
                                  {/* {moment(item.startTime).format("hh:mm A")} */}
                                  {moment(date1).format("hh:mm A")}
                                  {/* {item.sessionTime} */}
                                </div>
                                <div>Duration : {item.sessionDuration} hrs</div>
                                <div>
                                  {item.sessionFormat === "ONLINE"
                                    ? "On MAARG Platform"
                                    : item.sessionFormat}
                                </div>
                                {item.sessionFormat === "ONLINE" ? (
                                  <div
                                    className="d-flex"
                                    style={{ justifyContent: "space-between" }}
                                  >
                                    <div
                                      className="d-flex justify-content-end newuserTooltip"
                                      style={{ cursor: "pointer" }}
                                    >
                                      <a
                                        id="myLink"
                                        // href={item.vcUrl}
                                        href={"Javascript:void(0)"}
                                        // target="_blank"
                                        className="color-green"
                                        onClick={() => {
                                          newfunctionTime(item);
                                        }}
                                      >
                                        Click to join the session
                                      </a>
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={{
                                          left: "15px",
                                          top: "30px",
                                          width: "305px",
                                          height: "45px",
                                        }}
                                      >
                                        All Chats and Video Discussions may be
                                        recorded for quality purposes
                                      </span>
                                    </div>
                                    <div
                                      className="d-flex justify-content-end newuserTooltip"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        navigator.clipboard.writeText(
                                          item.vcUrl
                                        );
                                        setLinkToogleCopy(true);
                                        setLinkToogleText(
                                          "Your MAARG Session Link is copied"
                                        );
                                      }}
                                    >
                                      <span
                                        className="tooltiptext tooltip-bottom"
                                        style={
                                          linkToggleCopy
                                            ? {
                                                left: "-35px",
                                                top: "30px",
                                                width: "240px",
                                                backgroundColor:
                                                  "rgb(184,153,207)",
                                              }
                                            : {
                                                left: "-35px",
                                                top: "30px",
                                                width: "240px",
                                                backgroundColor: "#816ab0",
                                              }
                                        }
                                      >
                                        {linkToggleText}
                                      </span>
                                      <ContentCopyIcon />
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {item.isSpeaker === true ? (
                                  <div className="mt-1">
                                    Invited As : <b>Speaker</b>
                                  </div>
                                ) : (
                                  ""
                                )}
                                <div
                                  className="d-flex justify-content-end newuserTooltip"
                                  style={{
                                    cursor: "pointer",
                                    alignItems: "end",
                                    justifyContent: "center",
                                    width: "40px",
                                    display: "flex",
                                    float: "right",
                                    marginTop: "1rem",
                                  }}
                                  onClick={() => {
                                    setSessionModalOpen(true);
                                    getSessionDetails(
                                      item?.cohortGroupSessionId
                                    );
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="16"
                                    height="16"
                                    fill="currentColor"
                                    class="bi bi-info-circle"
                                    viewBox="0 0 16 16"
                                  >
                                    <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z" />
                                    <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z" />
                                  </svg>
                                  <span
                                    className="tooltiptext tooltip-bottom"
                                    style={{
                                      left: "24px",
                                      top: "24px",
                                      width: "150px",
                                    }}
                                  >
                                    View Session Details
                                  </span>
                                </div>
                              </td>

                              <td className="matchList-tooltip p-0 match-data4">
                                {tableImageRow(
                                  item?.speakerUserList,
                                  item?.cohortGroupSessionId
                                )}
                              </td>
                              <td
                                className="matchList-tooltip p-0 match-data5"
                                style={{ position: "relative" }}
                              >
                                {tableSpeakerRow(
                                  item?.speakerUserList,
                                  item?.cohortGroupSessionId
                                )}
                              </td>

                              <td>{newfunctionFeedBackBoolean(item) && item.sessionStatus !== "CANCELLED" && item.sessionStatus !== "COMPLETED"  ? "CLOSED" : item.sessionStatus }</td>
                              {loggenInUser?.role !== "Admin" ? (
                                item.isSpeaker === true ? (
                                  item.sessionStatus !== "CANCELLED" && newfunctionFeedBackBoolean(item) ? (
                                    <div className="newuserTooltip">
                                      <div
                                        className="color-green"
                                        style={{
                                          cursor: "pointer",
                                          whiteSpace: "nowrap",
                                          width: "fit-content",
                                        }}
                                        onClick={() => {
                                          setCohortGroupSessionId(
                                            item?.cohortGroupSessionId
                                          );

                                          if (
                                            item?.isNotesSubmitted === false
                                          ) {
                                            setFeedbackMode(false);
                                            setSessionMomChildData(item);
                                            setActivePage(1);
                                          } else {
                                            setFeedbackMode(true);

                                            let params = {
                                              cohortGroupSessionId:
                                                item?.cohortGroupSessionId,
                                              addedBy: loggedIn?.id,
                                            };
                                            cohortSessionNotesViewFeedBack(
                                              params
                                            );
                                          }

                                          setTimeout(() => {
                                            setSessionMomModalOpen(true);
                                          }, 1000);
                                        }}
                                      >
                                        {item?.isNotesSubmitted === false
                                          ? "Session Notes"
                                          : "View Notes"}
                                      </div>
                                      <span
                                        className="tooltiptext tooltip-bottom "
                                        style={{
                                          left: "-1rem",
                                          top: "2.4rem",
                                          width: "14vw",
                                        }}
                                      >
                                        {item.isNotesSubmitted === false
                                          ? "Provide Session Notes"
                                          : "View Session Notes"}
                                      </span>
                                    </div>
                                  ) : (
                                    <div style={{ padding: "5" }}>- -</div>
                                  )
                                ) : (
                                  <>
                                    <td>
                                      {item.sessionStatus !== "CANCELLED" && newfunctionFeedBackBoolean(item) ? (
                                        <div className="newuserTooltip">
                                          <div
                                            className="color-green"
                                            style={{
                                              cursor: "pointer",
                                              whiteSpace: "nowrap",
                                            }}
                                            onClick={() => {
                                              setCohortGroupSessionId(
                                                item?.cohortGroupSessionId
                                              );
                                              setTimeout(() => {
                                                setMentorFeedbackModalOpen(
                                                  true
                                                );
                                              }, 750);
                                              if (
                                                item?.isFeedbackSubmitted ===
                                                false
                                              ) {
                                                setFeedbackMode(false);
                                              } else {
                                                setFeedbackMode(true);
                                                getFeedBackData(
                                                  item?.cohortGroupSessionId
                                                );
                                              }
                                            }}
                                          >
                                            {item?.isFeedbackSubmitted === false
                                              ? "Give FeedBack"
                                              : "View FeedBack"}
                                          </div>
                                          <span
                                            className="tooltiptext tooltip-bottom "
                                            style={{
                                              left: "-1rem",
                                              top: "2.1rem",
                                              width: "14vw",
                                            }}
                                          >
                                            {item?.isFeedbackSubmitted === false
                                              ? "Give FeedBack to Session"
                                              : "View FeedBack to Session"}
                                          </span>
                                        </div>
                                      ) : (
                                        <div style={{ padding: "5" }}>- -</div>
                                      )}
                                    {(item?.recording !== undefined &&
                                    item?.recording !== "" && item?.recording !== null )  ? (
                                    <>
                                      <div className="newuserTooltip">
                                        <div
                                          className="color-green mt-1"
                                          style={{
                                            cursor: "pointer",
                                            whiteSpace: "nowrap",
                                            width: "fit-content",
                                          }}
                                          onClick={() => {
                                            handleView(item?.recording,item?.recordings,item?.cohortAdminId);
                                          }}
                                        >
                                          View Recording
                                        </div>
                                        <span
                                          className="tooltiptext tooltip-bottom "
                                          style={{
                                            left: "3rem",
                                            top: "2.4rem",
                                            width: "150px",
                                          }}
                                        >
                                          Play Recording
                                        </span>
                                      </div>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                    </td>
                                  </>
                                )
                              ) : (
                                ""
                              )}
                            </tr>
                          </tbody>
                        </>
                      );
                    })}
                </table>
                <div className="pagination-box">
                  {listGroupSessionPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={10}
                      totalItemsCount={listGroupSessionPaginate.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
              </div>
            </div>
          ) : (
            <div className="no-records">No Records Found</div>
          )}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    startUpApplication: state.StartUpReducer.StartUpApplications.data,
    startUpApplicationPagineate:
      state.StartUpReducer.StartUpApplications.paginate,
    getCounterStartUp: state.StartUpReducer.getCountersStartUpList.data,
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    getNamesListData: state.AdminMentorReducer.getNamesList?.data,
    getTableData: state.MentorReducer.getCohortMentorList.data,
    getTableDataPaginate: state.MentorReducer.getCohortMentorList.paginate,
    getTableCounterData:
      state.AdminMentorReducer.getCohortApplicationCounter.data,
    getStepperData: state.AdminMentorReducer.getStepperList.list,
    listGroupSessionPaginate:
      state.MentorReducer.listCohortGroupSession.paginate,
    listGroupSessionData: state.MentorReducer.listCohortGroupSession.data,
    detailsGroupSessionData: state.MentorReducer.detailsCohortGroupSession.data,
    invitedSessionList: state.MentorReducer.listSessionMemberList.data,
    invitedSessionListPaginate:
      state.MentorReducer.listSessionMemberList.paginate,
    groupSessionCounter:
      state.MentorReducer.listCohortGroupSessionCounters.data,
    sessionFeedBackData: state.MentorReducer.cohortViewFeedBack.data,
    sessionNotesFeedBackData:
      state.MentorReducer.cohortSessionNotesViewFeedBack,
  };
};
export default connect(mapStateToProps, {
  getPredefineOptionsList,
  getStepperTooltipData,
  getNamesList,
  getMentorCohortApplicationList,
  getCohortApplicationCounter,
  listGroupSession,
  detailsGroupSession,
  invitedSessionMembersList,
  statusGroupSession,
  listGroupSessionCounter,
  cohortSessionGiveFeedBack,
  cohortSessionViewFeedBack,
  cohortSessionNotesGiveFeedBack,
  cohortSessionNotesViewFeedBack,
})(withRouter(CohortCreateSession));